<template>
  <!-- 儿科眼科产科老年科 超级管理员 管理员内部layout -->
  <a-layout class="admin-basic-layout-wrapper">
    <!-- left -->
    <a-drawer
      placement="left"
      :closable="false"
      :visible="showDrawer"
      @close="toggleDrawer"
      :bodyStyle="{ padding: 0, height: '100%' }"
      :destroyOnClose="true"
      width="210"
    >
      <admin-sider v-if="isMobile" />
    </a-drawer>
    <admin-sider v-if="!isMobile" />

    <!-- right -->
    <a-layout
      :style="{
        'padding-left': isMobile ? 0 : isCollapsed ? '80px' : '210px',
        transition: 'all 0.2s'
      }"
    >
      <!-- header -->
      <admin-header></admin-header>
      <!-- history -->
      <history-tool-bar></history-tool-bar>
      <!-- content -->
      <a-layout-content class="content-wrap">
        <div class="content">
          <router-view />
        </div>
      </a-layout-content>
    </a-layout>
  </a-layout>
</template>
<script>
import { mapGetters, mapMutations } from "vuex";
import { SET_DRAWER } from "@/store/types";
import AdminSider from "@/components/AdminSider/Index";
import AdminHeader from "@/components/AdminHeader/Index";
import HistoryToolBar from "@/components/HistoryToolBar/Index";

export default {
  components: {
    AdminSider,
    AdminHeader,
    HistoryToolBar
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["isMobile", "showDrawer", "isCollapsed"])
  },
  methods: {
    ...mapMutations({
      setDrawer: SET_DRAWER
    }),
    toggleDrawer() {
      this.setDrawer(!this.showDrawer);
    }
  }
};
</script>
<style lang="less" scoped>
.admin-basic-layout-wrapper {
  min-height: 100%;

  .content-wrap {
    padding: 24px 24px;
    margin-top: 108px;
    overflow: auto;
    .content {
      padding: 24px;
      background-color: #fff;
      min-height: 100%;
      border-radius: 2px;
    }
  }
}
</style>
